import React from "react";

const NotFound = () => {
  return <div>Страница не найдена</div>;
};

export default NotFound;
